import React from "react";
import "./Personal.scss";
import linkedin from "@assets/img/logo/Linkedin-color.svg";
import { EditOutlined } from "@ant-design/icons";
import { Avatar } from "antd";
import { TUserSectionProp } from "@utils/Interfaces";

const Personal: React.FC<TUserSectionProp> = ({
  setIsEditProfileVisible,
  setActiveTab,
  userProfile,
}) => {
  return (
    <div className="card card-profile personal">
      <div
        className="edit-action"
        onClick={() => {
          setIsEditProfileVisible(true);
          setActiveTab("1");
        }}
      >
        <EditOutlined />
      </div>
      <div className="d-flex gap-3 align-items-center">
        <div className="flex-shrink-0">
          {userProfile?.avatar ? (
            <Avatar size={80} src={userProfile.avatar} />
          ) : (
            <Avatar
              size={80}
              style={{
                backgroundColor: "#fde3cf",
                color: "#f56a00",
              }}
            >
              {userProfile?.name[0]}
            </Avatar>
          )}
        </div>
        <div className="flex-grow-1">
          <div className="profile-name">{userProfile.display_name}</div>
          <div className="profile-position">Fullstack Developer</div>
          <div className="profile-location">{userProfile.location}</div>
        </div>
      </div>
      <div className="personal-profile">
        <div className="title">Personal Information</div>
        <div className="personal-group row g-2">
          <div className="col-4">
            <div className="info-title">First Name</div>
            <div className="info-value">{userProfile.first_name}</div>
          </div>
          <div className="col-4">
            <div className="info-title">Last Name</div>
            <div className="info-value">{userProfile.last_name}</div>
          </div>
          <div className="col-4">
            <div className="info-title">Email Address</div>
            <div className="info-value">{userProfile.email}</div>
          </div>
          <div className="col-4">
            <div className="info-title">Phone</div>
            <div className="info-value">{userProfile.phone}</div>
          </div>
          <div className="col-4">
            <div className="info-title">Account ID</div>
            <div className="info-value">{userProfile.id}</div>
          </div>
          <div className="col-4">
            <div className="info-title">Contact Info</div>
            <div className="info-value">
              <img src={linkedin} width={20} alt="logo" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Personal;
